import React from 'react';
import ReactDOM from 'react-dom';
import ProductPage from 'ProductPageRestructure/ProductPage';

const productPageIndexJson = JSON.parse(document.getElementById("productPageIndexJson").textContent); // eslint-disable-next-line
const breadcrumbs = JSON.parse(document.getElementById("breadcrumbJson").textContent); // eslint-disable-next-line
const salonCountries = JSON.parse(document.getElementById("salonCountries").textContent); // eslint-disable-next-line
const layout = JSON.parse(document.getElementById("Layout").textContent); // eslint-disable-next-line
var language = document.getElementById('divlang').getAttribute('data-id'); // eslint-disable-next-line

ReactDOM.render(<ProductPage product={productPageIndexJson} breadcrumbs={breadcrumbs} salonCountries={salonCountries} language={language} {...layout.Model} />, document.getElementById('productPageIndex'));
